import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

// Enquanto a primeira resposta não chega, a tela mostra zeros formatados em vez
// de campos vazios, que dariam a impressão de erro.
const EMPTY_SUMMARY = {
  totalProduced: 0,
  totalProducedFormatted: 'R$ 0,00',
  totalReceived: 0,
  totalReceivedFormatted: 'R$ 0,00',
  totalToReceive: 0,
  totalToReceiveFormatted: 'R$ 0,00',
  receivedPercentage: 0,
  proceduresCount: 0,
};

// Produção clínica do período. O recorte por período e situação é feito pela API,
// então o hook refaz a busca sempre que um desses filtros muda.
export function useClinicalProduction({ selectedDate, status, professionalId }) {
  const navigate = useNavigate();

  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [procedures, setProcedures] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProduction = useCallback(() => {
    setLoading(true);
    setError(null);

    const params = {
      selectedDate: selectedDate.format('YYYY/MM'),
      viewByYear: false,
      viewAllPeriod: false,
      status,
    };

    // Sem profissional escolhido o parâmetro não vai, e a API devolve a clínica toda.
    if (professionalId) {
      params.professionalId = professionalId;
    }

    quarkusApi
      .get('/reports/clinical-production', {
        headers: { Authorization: sessionStorage.getItem('token') },
        params,
      })
      .then((returnFromApi) => {
        setSummary(returnFromApi.data.summary ?? EMPTY_SUMMARY);
        setProcedures(returnFromApi.data.procedures ?? []);
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [selectedDate, status, professionalId, navigate]);

  useEffect(() => {
    fetchProduction();
  }, [fetchProduction]);

  return { summary, procedures, isLoading, error, refetch: fetchProduction };
}
